const pxToRem = (value)=>`${value / 16}rem`;
const fontWeights = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700
};
const typography = {
    ...fontWeights,
    pxToRem,
    fontFamily: '"Roboto", "Arial", sans-serif',
    h1: {
        fontWeight: fontWeights.bold,
        lineHeight: 64 / 48,
        fontSize: pxToRem(48),
        letterSpacing: 0
    },
    h2: {
        fontWeight: fontWeights.bold,
        lineHeight: 48 / 32,
        fontSize: pxToRem(32),
        letterSpacing: 0
    },
    h3: {
        fontWeight: fontWeights.bold,
        lineHeight: 36 / 24,
        fontSize: pxToRem(24),
        letterSpacing: 0
    },
    h4: {
        fontWeight: fontWeights.bold,
        lineHeight: 32 / 20,
        fontSize: pxToRem(20),
        letterSpacing: 0
    },
    h5: {
        fontWeight: fontWeights.bold,
        lineHeight: 28 / 18,
        fontSize: pxToRem(18),
        letterSpacing: 0
    },
    h6: {
        fontWeight: fontWeights.bold,
        lineHeight: 24 / 16,
        fontSize: pxToRem(16),
        letterSpacing: 0
    },
    subtitle1: {
        fontWeight: fontWeights.regular,
        lineHeight: 28 / 16,
        fontSize: pxToRem(16),
        letterSpacing: 0
    },
    subtitle2: {
        fontWeight: fontWeights.medium,
        lineHeight: 22 / 14,
        fontSize: pxToRem(14),
        letterSpacing: 0
    },
    body1: {
        lineHeight: 24 / 16,
        fontSize: pxToRem(16),
        letterSpacing: 0
    },
    body2: {
        lineHeight: 22 / 14,
        fontSize: pxToRem(14),
        letterSpacing: 0
    },
    caption: {
        lineHeight: 20 / 12,
        fontSize: pxToRem(12),
        letterSpacing: 0
    },
    overline: {
        fontWeight: fontWeights.regular,
        lineHeight: 32 / 12,
        fontSize: pxToRem(12),
        textTransform: 'uppercase',
        letterSpacing: 1
    },
    button: {
        fontWeight: fontWeights.bold,
        lineHeight: 24 / 14,
        fontSize: pxToRem(14),
        textTransform: 'capitalize',
        letterSpacing: 0
    }
};
export default typography;
